import { Moment } from 'moment';
import {
	FixtureTypes,
	PortActionTypes,
} from '@shared/utils/constants';
import { Values } from '@shared/utils/objectEnums';
import { getEstDeliveryDateFromPortCall } from '@shared/utils/calculateTcOutDates';
import { toMoment } from '@shared/utils/date';
import { getPortDaysForTargetEtd } from '@shared/utils/portCallDays';
import { ItineraryPortCallDto } from '@client/screens/estimates/details/helpers/types';

export const getSetEtdDisabledReason = (
	portCall: ItineraryPortCallDto,
	fixtureType: Values<typeof FixtureTypes> | null | undefined,
) => {
	if (portCall.departureDate != null) {
		return 'The vessel has already departed';
	}

	if (
		fixtureType === FixtureTypes.TC_OUT &&
		portCall.actions.some((a) => a.event === PortActionTypes.REDELIVERY)
	) {
		return 'ETD follows the estimated redelivery date of the contract';
	}

	if (getEstDeliveryDateFromPortCall(portCall) == null) {
		return 'No arrival date to calculate from';
	}

	return null;
};

export const isEtdSetManually = (portCall: ItineraryPortCallDto) => (
	portCall.departureDate == null &&
	portCall.manualEstimatedDepartureDate != null &&
	portCall.estimatedDepartureDate != null &&
	Math.abs(toMoment(portCall.estimatedDepartureDate).diff(portCall.manualEstimatedDepartureDate, 'minutes', true)) < 1
);

export const getPortDaysForPortCallEtd = (
	portCall: ItineraryPortCallDto,
	targetEtd: Moment,
) => {
	const etdBaseDate = getEstDeliveryDateFromPortCall(portCall);

	if (etdBaseDate == null) {
		return null;
	}

	return getPortDaysForTargetEtd({
		arrivalDate: etdBaseDate,
		targetEtd,
		days: portCall,
		hasLoading: portCall.PortCallActions.some((pca) => pca.event === PortActionTypes.LOADING),
		hasDischarging: portCall.PortCallActions.some((pca) => pca.event === PortActionTypes.DISCHARGING),
	});
};
